export default __webpack_public_path__ + "static/media/next-level-bg.442be2c3.svg";